// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + (chunkId === "4883" ? "Core_Layuout" : chunkId) + "." + {"260": "07d0538d","4883": "8a5165f1",}[chunkId] + ".css"
}